// UserMore.js
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';

import UserMore from '../page/UserMore.jsx';
import fetchFeeds from '../action/fetchFeeds.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import { getFeedCategory } from '../resource/feedUtils.js';

const mapStateToProps = (
  state,
  {
    location,
    match: {
      params: { category: paramCategory },
    },
  }
) => {
  const category = getFeedCategory({
    category: paramCategory,
    search: location.search,
  });
  const selectPath = ['home', 'users', category];

  return {
    category,
    isFirstPageFetched: getNetworkingData(
      state,
      [...selectPath, 1],
      'isFetched'
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFeeds: ({ type, page, limit, httpProxyHeaders }) =>
      dispatch(fetchFeeds({ type, page, limit, httpProxyHeaders })),
    goBack: () => dispatch(goBack()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserMore);
